import beautify from 'js-beautify';

var editor = ace.edit("editor");
editor.setTheme("ace/theme/monokai");
editor.session.setMode("ace/mode/html");

// Toggle visibility of input fields based on content type
function toggleContentType() {
    var contentType = document.getElementById("contentType").value;
    var imageInputs = document.getElementById("imageInputs");
    var videoInputs = document.getElementById("videoInputs");
    if (contentType === 'video') {
        imageInputs.classList.add('hidden');
        videoInputs.classList.remove('hidden');
    } else {
        videoInputs.classList.add('hidden');
        imageInputs.classList.remove('hidden');
    }
}

// Dynamically generate input fields for each product
function generateProductInputs() {
    var count = parseInt(document.getElementById("productCount").value, 10);
    var container = document.getElementById("productInputs");
    container.innerHTML = ''; // Clear previous inputs

    for (let i = 0; i < count; i++) {
        container.innerHTML += `<div class="product-container">
            <label for="productMobileImage${i}">Product ${i + 1} Mobile Image:</label>
            <input type="text" id="productMobileImage${i}" value="MEDIA/lp/2024/LP_st_valentin/LP_st_valentin_hero_MOB.jpg?$staticlink$">
            <label for="productDesktopImage${i}">Product ${i + 1} Desktop Image:</label>
            <input type="text" id="productDesktopImage${i}" value="MEDIA/lp/2024/LP_st_valentin/LP_st_valentin_hero_DESK.jpg?$staticlink$">
            <label for="productLink${i}">Product ${i + 1} Link:</label>
            <input type="text" id="productLink${i}" value="$url('Search-Show','cgid','LingerieInnovation1')$">
            <label for="productText${i}">Product ${i + 1} Text:</label>
            <input type="text" id="productText${i}" value="Lingerie rouge">
            <label for="productButtonText${i}">Product ${i + 1} Button Text:</label>
            <input type="text" id="productButtonText${i}" value="Découvrir">
        </div>`;
    }
}

// Generate HTML based on user inputs
function generateHTML() {
    var contentType = document.getElementById("contentType").value;
    var heroMobile = document.getElementById("heroMobile").value;
    var heroDesktop = document.getElementById("heroDesktop").value;
    var videoMobileId = document.getElementById("videoMobileId").value;
    var videoDesktopId = document.getElementById("videoDesktopId").value;
    var heroTitle = document.getElementById("heroTitle").value;
    var heroDate = document.getElementById("heroDate").value;
    var heroDesktopText = document.getElementById("heroDesktopText").value;
    var heroMobileText = document.getElementById("heroMobileText").value;
    var rowProductCount = parseInt(document.getElementById("rowProductCount").value, 10);
    var productCount = parseInt(document.getElementById("productCount").value, 10);

    let htmlCode = `<link href="MEDIA/css/Template_T9/main.min.css?$staticlink$" rel="stylesheet">`;

    htmlCode += `
    \n
    <!-- CSS pour le menu -->
    <style>
        .breadcrumb,
        .breadcrumbWrapper {
            display: none !important;
        }

        #header:not(:hover):not(.headroom--not-top) {
            background: transparent;
        }

        #header:not(:hover):not(.headroom--not-top) .headerMenu__link {
            color: #fff;
        }

        /* #header:not(:hover):not(.headroom--not-top) [class^=icon-],
        #header:not(:hover):not(.headroom--not-top) [class*=" icon-"] {
        background-color: #fff;
        } */

        #header:not(:hover):not(.headroom--not-top) [class^=icon-],
        #header:not(:hover):not(.headroom--not-top) [class*=" icon-"] {
            background-color: #fff;
        }

        #header:not(:hover):not(.headroom--not-top) .header__logoImage.-globalLogo {
            display: none;
        }

        #header:not(:hover):not(.headroom--not-top) .header__logoImage.-transparentLogo {
            display: block;
        }

        #header:not(:hover):not(.headroom--not-top) .header__iconUser {
            border: 1px solid #fff;
            color: #fff;
        }

        .header.headroom~#root .main {
            padding-top: 0 !important;
        }
    </style>
    \n
    <style>
        @media screen and (min-width:1024px) {
            .Template_T9 .Template_T9__bloc-produit{
                grid-template-columns: repeat(${rowProductCount}, 1fr) !important;
            }
        }
    </style>
    \n
    `;

    htmlCode += `<section class="Template_T9">\n`;

    // Include hero image or video based on selected content type
    if (contentType === 'image') {
        htmlCode += `    <article class="Template_T9__bloc-hero">\n    <div class="Template_T9__bloc-hero-img">\n        <picture>\n            <source srcset="${heroMobile}" media="(max-width:1023px)">\n            <img src="${heroDesktop}" alt="Hero Image" class="x-width-100 x-height-100 x-fit-cover-bot">\n        </picture>\n    </div>\n`;
    } else {
        htmlCode += `    <article class="Template_T9__bloc-hero">\n    <div class="Template_T9__bloc-hero-img">\n <div class="videoContainer js-videoPlayer" data-desktop-id="${videoDesktopId}" data-mobile-id="${videoMobileId}">\n              
            <video data-desktop-focal-x="0.5" data-desktop-focal-y="0.5" data-mobile-focal-x="0.5" data-mobile-focal-y="0.5" playsinline="" autoplay="" loop="" muted=""></video>\n
                <div class="u-center-abs loaderContainer js-video-loader">\n
                        <div class="loading">\n
                            <div class="loader-element"></div>\n
                        </div>\n
                </div>\n
            </div>\n
        </div>\n`;
    }

    // Hero text and link
    htmlCode += `    <div class="Template_T9__bloc-hero-text">\n        <h1 class="Template_T9__titre x-upper heavitas x-margin-b-05-rem-l">\n            SAINT<span class="x-hide-mobile">&nbsp;</span><br class="x-hide-desktop">${heroTitle}\n        </h1>\n        <p class="heading-02 x-fweight-600 x-upper x-margin-b-15-rem x-margin-b-20-rem-l">\n            <span class="x-fsize-07 x-fsize-10-l">\n                ${heroDate}\n            </span>\n        </p>\n        <p class="body-03 x-upper x-hide-mobile">\n            ${heroDesktopText}\n        </p>\n        <p class="body-03 x-upper x-hide-desktop">\n            ${heroMobileText}\n        </p>\n    </div>\n    </article>\n`;

    htmlCode += `<article class="Template_T9__bloc-produit">\n`;

    // Dynamically generate HTML for each product
    for (let i = 0; i < productCount; i++) {
        let mobileImage = document.getElementById(`productMobileImage${i}`).value;
        let desktopImage = document.getElementById(`productDesktopImage${i}`).value;
        let productLink = document.getElementById(`productLink${i}`).value;
        let productText = document.getElementById(`productText${i}`).value;
        let buttonText = document.getElementById(`productButtonText${i}`).value;

        htmlCode += `    <div class="Template_T9__bloc-produit-item">\n        <a class="x-width-100 x-height-100 x-flex x-relative" href="${productLink}">\n            <picture class="x-width-100 x-height-100 x-flex x-relative">\n                <source srcset="${mobileImage}" media="(max-width:1023px)">\n                <img src="${desktopImage}" alt="${productText}" class="x-width-100 x-height-100 x-fit-cover">\n            </picture>\n            <div class="Template_T9__bloc-produit-item-text">\n                <p class="title-01 x-fweight-600 x-upper x-white">${productText}</p>\n                <button type="button" class="x-hide-mobile btn btn-secondary -white -small x-upper">\n                    <span class="body-03">${buttonText}</span>\n                </button>\n            </div>\n        </a>\n    </div>\n`;
    }

    htmlCode += `</article>\n`;
    htmlCode += `</section>\n`;

    htmlCode += `
        <!-- JS Scroll Magic - 2.0.8 -->
        <script type="text/javascript" src="MEDIA/js/scrollMagic/gsap_3.12.2.min.js?$staticlink$"></script>
        <script type="text/javascript" src="MEDIA/js/scrollMagic/ScrollMagic_2.0.8.min.js?$staticlink$"></script>
        <script type="text/javascript"
            src="MEDIA/js/scrollMagic/ScrollMagic_2.0.8_plugins_animation.gsap.min.js?$staticlink$"></script>


        <script type="text/javascript" src="MEDIA/css/Template_T9/main.min.js?$staticlink$"></script>
    `;

    // Beautify the HTML code
    editor.session.setValue(beautify.html(htmlCode));

}

document.querySelector("#contentType").addEventListener("change", toggleContentType);

document.querySelector("#productCount").addEventListener("change", generateProductInputs);

document.querySelector(".button-html").addEventListener("click", generateHTML);

window.onload = function () {
    generateProductInputs(); // Generate initial product inputs on load
    toggleContentType(); // Set initial visibility state for content type inputs
};
